import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import ScrollMagic from "scrollmagic";
import FontFaceObserver from 'fontfaceobserver'
import { log } from "pusher-js";
import { functions } from "lodash";

gsap.registerPlugin(ScrollTrigger)

let isMain = false;
let ww = window.innerWidth;
let wh = window.innerHeight;
let isMobile = ww < 768 || wh < 491;
let isDesktop = ww >= 1280;
let isTablet = ww < 1280 && ww >= 768;
let scrollingScenes = [];
let isSmallDesktop = ww >= 1280 && ww < 1600;
let isFHD = ww >= 1600 && ww <= 1920;
let isLarge = ww > 1920;
let easeScenes = [];
let updateEasingScenes = true;
let controller = new ScrollMagic.Controller();
let bikeFrame;
let geometryFrame;
let sprites = [];
let geometry;
let motor;
let battery;
let colors;
let splits = [];

let canvasDensity = Math.min(2, window.devicePixelRatio);

let bikeFrameOptions = {
    baseURL: process.env.MIX_AWS_URL + "assets/images/frame/Frame Only",
    ratio: 1716 / 965, // ratio is important, you can directly pass ratio of image's height and width
    extension: ".jpg",
    frameCount: 91, // total number of frames before creating sprites
    lastFrame: "last.jpg", // lastpart of last frame with extension will create frame_lastframe.jpg
    numberPadding: 2, // number of zeros on original file, will be used to access each frame
}

let geometryOptions = {
    baseURL: process.env.MIX_AWS_URL + "assets/images/geometry/G",
    ratio: 1920 / 1080,
    extension: ".webp",
    frameCount: 191,
    lastFrame: "Final.webp",
    numberPadding: 3,
}

let motorOptions = {
    baseURL: process.env.MIX_AWS_URL + "assets/images/motor/large/Motor",
    ratio: 1920 / 1080,
    frameCount: 301,
    extension: ".jpg",
    lastFrame: "Frame.png",
    numberPadding: 5,
}

let colorsOptions = {
    baseURL: process.env.MIX_AWS_URL + "assets/images/colors/large/UOC",
    ratio: 1920 / 1080,
    frameCount: 762,
    extension: ".jpg",
    lastFrame: "Frame.jpg",
    numberPadding: 3,
}

let batteryOptions = {
    baseURL: process.env.MIX_AWS_URL + "assets/images/battery/Battery",
    ratio: 1920 / 1080,
    extension: ".jpg",
    frameCount: 240,
    lastFrame: "Last.jpg",
    numberPadding: 3,
}

// uncomment following code to support different screen sizes
// change sprite url
if (isMobile && window.devicePixelRatio === 1) {
    // this block will load images for mobile devices that don't have high pixel density
    //bikeFrameOptions.baseURL = "assets/images/frame/sd/frame_";

    motorOptions.baseURL = process.env.MIX_AWS_URL + "assets/images/motor/sd/Motor";
} else if (isMobile && window.devicePixelRatio > 1 || isTablet) {
    // this block will load images for mobile devices with high pixel density and tablets
    // keep canvas density to one for tablet
    if (isTablet) canvasDensity = 1;

    // bikeFrameOptions.baseURL = "assets/images/frame/md/frame_";

    motorOptions.baseURL = process.env.MIX_AWS_URL + "assets/images/motor/md/Motor";
} else if (isSmallDesktop) {
    // this block will load images for small desktops. You can add more conditions to support different sizes.

    motorOptions.baseURL = process.env.MIX_AWS_URL + "assets/images/motor/hd/Motor";
} else if (isFHD) {
    motorOptions.baseURL = process.env.MIX_AWS_URL + "assets/images/motor/fhd/Motor";
}

gsap.defaults({
    ease: "linear",
    duration: 1,
    overwrite: "auto"
});

$(document).ready(function () {
    //If you don't want use timer and check innerHTML you can try this event
    isMain = document.querySelector(".main");

    let tempLink = document.createElement('a'),
        supportsAR = tempLink.relList.supports('ar');

    if (supportsAR) {
        $(".ar_icon, .ar_link").addClass("iOS");
    }

    if (!isMain) {
        return;
    }

    initSprites();

    changeHeaderColor();
    lazyLoadContent();
    scrollBikeFrame();
    performSceneEasing();
    observeCanvasElements();
    playSuspensionVideo();
    playAsistVideo();
    displayAssembly();
    adjustTabs();
    appTextScroll();
    displayTextScroll();

    cityIntroScroll();

    $(".main-display__background img").each(() => {
        if (this.complete) {
            setImage(this);
        } else {
            $(this).on("load", function () {
                setImage(this);
            })
        }
    });

    setImage($(".main-display__background img")[0]);

    let resizeTimer;
    $(window).on('resize', () => {
        clearTimeout(resizeTimer);
        let widthChanged = ww !== window.innerWidth;
        ww = window.innerWidth;
        wh = window.innerHeight;

        isMobile = ww < 768 || wh < 491;
        isTablet = ww < 1280;
        isDesktop = ww >= 1280;
        isSmallDesktop = ww >= 1280 && ww < 1600;
        isFHD = ww >= 1600 && ww <= 1920;
        isLarge = ww > 1920;

        if (widthChanged) {
            resizeTimer = setTimeout(function () {
                for (let i = 0; i < scrollingScenes.length; i++) {
                    if (scrollingScenes[i].update) {
                        scrollingScenes[i].update();
                    }
                }

                for (let i = 0; i < easeScenes.length; i++) {
                    if (easeScenes[i].update) {
                        easeScenes[i].update();
                    }
                }

                setImage($(".main-display__background img")[0]);

                adjustTabs();

                if (!isMobile) {
                    setMainVideoPosition();
                }
            }, 500);
        }
    });

    $(".navbox a").each(function () {
        let tween = gsap.to(this, {
            color: "#979797",
            duration: 0.2,
            paused: true
        })

        $(this).on("mouseenter touchstart", function () {
            tween.play();
        });

        $(this).on("mouseleave touchend", function (e) {
            if (e.type === "touchend") {
                gsap.delayedCall(0.3, function () {
                    tween.reverse();
                });
            } else {
                tween.reverse();
            }
        })
    });

    let $header = $('.header');
    let offset = $header.height();
    offset = isMobile ? $header.height() + $(".main__navbox").height() : offset;
    $('.navbox a').on('click', function (e) {
        let anchor = $(this).attr('href');
        let target = $(this).is(".nav-active-flow");
        updateEasingScenes = false;

      if (anchor.substr(0, 1) === '#') {
        e.preventDefault();
        document.querySelector(anchor).scrollIntoView({block: "start", behavior: "smooth"})
        // $('html, body').animate({
        //   scrollTop: $(anchor).offset().top - offset
        // }, 500, "swing", function () {
        //
        //   updateEasingScenes = true;
        //   if (target && !isMobile) {
        //     $('html, body').animate({
        //       scrollTop: $(".main-power__sticky").offset().top - offset + wh * 0.6
        //     }, 500);
        //   }
        //
        // });
      }
    });


    if (isMobile) {
        scrollMobileMotor();
        navboxScrollEffect();
        universeOfColorsFrames();
        return;
    }

    if (isDesktop) designScaleDown();
    designParallax();
    frameCoverAnimation();
    powerScaleDown();
    scrollMotorFrames();
    scrollBatteryFrames();
    motorBoxTextAnimation();
    setMainVideoPosition();
    bikeGalleryParallax();
    universeOfColorsFrames();
});

function initSprites() {
    if (!isMobile  && $(".main__video video").length) {
        var mainVideoPlayed = false;
        var mainVideoLoaded = false;
        var main_video = $('.main__video video');
        var mainVideoIsPlaying = false;
        var playVideoTimer;
        var autoPlayAttempts = 0;
        var bikeTitleAnimation = gsap.fromTo(".main__bike", {
            yPercent: 100,
            opacity: 1
        }, {
            yPercent: 0,
            paused: true,
            duration: 1.2,
            ease: "power2.out"
        });
        var videoSource = main_video.find("source").data("src");
        main_video.attr("src", videoSource);
        main_video[0].load();
        // if video is cached then directly play video
        if (main_video[0].readyState === 4) {
            main_video[0].play();
        } else {
            // adds event to play video when it is ready
            main_video.on("canplaythrough", function () {
                if (mainVideoLoaded) return;
                mainVideoLoaded = true;
                main_video[0].play();
            });
        }

        // once video is done playing, check if font has loaded
        main_video[0].addEventListener("ended", function () {
            if (mainVideoPlayed) return;
            mainVideoPlayed = true;
            var tl = gsap.timeline()

                .set(".main__video img", {
                    display: "block",
                    position: "absolute",
                    opacity: 1
                })
                .to(main_video, {
                    display: "none",
                    opacity: 0,
                    duration: 5
                })
                .set(".main__video img", {
                    display: "block",
                    position: "relative",
                    opacity: 1
                })
            loadContent();
        });
        main_video[0].addEventListener("timeupdate", function () {
            if (main_video[0].currentTime >= 6) {
                bikeTitleAnimation.play();
            }
        });

        main_video[0].addEventListener("playing", function () {
            mainVideoIsPlaying = true;
        });


        playVideoTimer = setInterval(function () {
            autoPlayAttempts++;
            if (!mainVideoPlayed && main_video[0].readyState === 4 && !mainVideoIsPlaying) {
                main_video[0].play();
            } else if (mainVideoPlayed) {
                clearInterval(playVideoTimer);
            }

            if (autoPlayAttempts > 7 && !mainVideoIsPlaying) {
                clearInterval(playVideoTimer);
                gsap.timeline()
                    .set(main_video, {
                        display: "none"
                    })
                    .fromTo(".main__video img", {
                        opacity: 0,
                        display: "block"
                    }, {
                        display: "block",
                        opacity: 1
                    })
                    .add(bikeTitleAnimation.play());
                loadContent();
            }
        }, 2000);

    } else {
        loadContent();
    }

    if ($(".main-frame__image").length){

    geometryFrame = new VideoSprite({
        name: "geometry",
        container: document.querySelector(".main-frame__image"),
        backgroundColor: 0xffffff,
        parent: document.querySelector(".main-frame__image")
    }, geometryOptions);

    sprites.push(geometryFrame);
    }

    // bikeFrame = new VideoSprite({
    //     name: "frame",
    //     container: document.querySelector(".main-frame__image"),
    //     backgroundColor: 0xffffff,
    //     parent: document.querySelector(".main-frame__image")
    // }, bikeFrameOptions);

    // sprites.push(bikeFrame);
    if ($(".main-motor__image").length){

    motor = new VideoSprite({
        name: "motor",
        container: document.querySelector(".main-motor__image"),
        backgroundColor: 0x000000,
        parent: document.querySelector(".main-motor__image .canvas-wrapper")
    }, motorOptions);

    sprites.push(motor);
    }

    if ($(".main-colors").length){

    colors = new VideoSprite({
        name: "color",
        container: document.querySelector(".main-colors"),
        backgroundColor: 0x000000,
        parent: document.querySelector(".main-colors .canvas-wrapper")
    }, colorsOptions);

    sprites.push(colors);
    }

if ($(".main-battery__image").length){

    if (!isMobile) {
        battery = new VideoSprite({
            name: "battery",
            container: document.querySelector(".main-battery__image"),
            backgroundColor: 0x000000
        }, batteryOptions);

        sprites.push(battery);

        var font = new FontFaceObserver('Object Sans', {
            weight: 700
        });

        // once font is loaded, starts loading frames
        font.load(null, 10000).then(function () {
            addSplit();
        }, function () {
            console.log("failed to load font");
            addSplit();
        });
    }
}
}

function loadContent() {
    if (!isMobile) {
        var resizeTimer;
        var lastWidth = ww;
        $(window).on('resize', function (e) {
            clearTimeout(resizeTimer);
            var widthChanged = ww !== lastWidth;
            lastWidth = ww = window.innerWidth;
            wh = window.innerHeight;

            resizeTimer = setTimeout(function () {
                if (widthChanged) {
                    recreateSplit();
                }
            }, 500);

        });

    }

    gsap.delayedCall(1, lazyLoadSprites);
}

function setMainVideoPosition() {
    let aspectRatio = wh / ww;

    let videoHeight = $(".main__video video").height();

    let $mainVideo = $(".main__video");
    if (aspectRatio > 0.75 || videoHeight > wh) {
        $mainVideo.addClass("mainVideoCenter");
        $mainVideo.removeClass("mainVideoCover");
    } else if (aspectRatio <= 0.75 || aspectRatio > 0.6) {
        $mainVideo.addClass("mainVideoCover");
        $mainVideo.removeClass("mainVideoCenter");
    } else {
        $mainVideo.removeClass("mainVideoCover");
        $mainVideo.removeClass("mainVideoCenter");
    }
}

function setImage(target) {
    let container = $(".main-display__display");
    let containerWidth = container.width();
    let containerHeight = container.height();
    gsap.set(".main-display__background", {
        top: 0,
        left: 0,
        immediateRender: true,
    })
    let backgroundContainerBox = document.querySelector(".main-display__background").getBoundingClientRect();
    let originalWidth = 100 * containerWidth / 12.78;
    let originalHeight = 100 * containerHeight / 17.97;
    let leftDistance = originalWidth / 100 * 44.51;
    let topDistance = originalHeight / 100 * 47.54;

    let bottomDistance = originalHeight / 100 * 34.49;
    let paddingBottom = wh - (wh * 0.2 + containerHeight);
    paddingBottom = isMobile ? wh - (wh * 0.4 + containerHeight) : paddingBottom;
    paddingBottom = Math.min(bottomDistance, paddingBottom);

    gsap.set(".main-display__in", {
        paddingTop: topDistance,
        paddingBottom: Math.min(300, bottomDistance),
        minHeight: containerHeight
    });


    let bgHeight = originalHeight + bottomDistance - paddingBottom;

    bgHeight = isMobile ? originalHeight : bgHeight

    gsap.set(".main-display__background img", {
        top: 0,
        left: -leftDistance + backgroundContainerBox.left,
        width: originalWidth,
        height: originalHeight
    });

    gsap.set(".main-display__background", {
        top: -topDistance,
        left: -backgroundContainerBox.left,
        width: $(window).width(),
        height: bgHeight
    });

    gsap.set(target, {
        opacity: 1
    })
}

function adjustTabs() {
    if (!isMobile) {
        let batteryHeadingHeight = 0
        let $batteryTabs = $(".battery__tabs h3");
        $batteryTabs.each(function (i, heading) {
            batteryHeadingHeight = Math.max(batteryHeadingHeight, $(heading).height());
        });
        $batteryTabs.height(batteryHeadingHeight);
    }

    $(".tabs__content").each(function (i, tab) {
        let maxHeight = 0;

        $(tab).find(".tab-pane").each(function (i, pane) {
            let newHeight = $(pane).height();
            maxHeight = maxHeight > newHeight ? maxHeight : newHeight;
        });

        $(tab).height(maxHeight).find(".tab-pan").height(maxHeight);

    });
}

function performSceneEasing() {
    gsap.ticker.add(function () {
        if (!updateEasingScenes) {
            for (let i = 0; i < easeScenes.length; i++) {
                easeScenes[i].follower.progress(easeScenes[i].tween.progress());
            }

            return;
        }

        for (let i = 0; i < easeScenes.length; i++) {
            let diff = easeScenes[i].tween.progress() - easeScenes[i].follower.progress();

            if (Math.abs(diff) < 0.01) {
                continue;
            }

            easeScenes[i].follower.progress(easeScenes[i].follower.progress() + diff * 0.07);
        }
    });
}

function updateFrames(target, obj) {
    if (target) {
        let frame = Math.round(obj.value * (target.options.frameCount - 1));

        if (frame !== target.options.frameCount - 1 && target.videoLoaded) {
            target.currentFrame = frame;
        } else if (target) {
            target.currentFrame = "last"
        }
        target.draw();
    }
}

// function getSprite(name) {
//     if (!sprites) return;
//     for (let i = 0; i < sprites.length; i++) {
//         if (sprites[i] && sprites[i].name === name) {
//             return sprites[i];
//         }
//     }
//
//     return null;
// }

function observeCanvasElements() {
    let spriteObserver = new IntersectionObserver((entries) => {
        entries.forEach(function (entry) {
            // let spriteName = $(entry.target).data("sprite");
            // let sprite = getSprite(spriteName);
            if (entry.isIntersecting) {
                for (let i = 0; i < easeScenes.length; i++) {
                    if (easeScenes[i].isSprite) {
                        easeScenes[i].follower.render(easeScenes[i].follower.time(), false, true);
                    }
                }
            }
        });
    }, {
        root: null,
        rootMargin: "200px",
        threshold: 0
    });

    $("[data-sprite]").each(function (i, elem) {
        spriteObserver.observe(elem);
    });
}

function addEmptySpans() {
    $('.splitScroll span').each(function (i, elem) {
        let className = elem.className;
        let spanText = $(elem).text();
        let split = spanText.split(" ");
        let html = "";

        for (let i = 0; i < split.length; i++) {
            let text = split[i];
            html += "<span class='" + className + "' >" + text + "</span>";
            if (i !== split.length - 1)
                html += "<span class='empty'> </span>";
        }

        $(elem).replaceWith(html);
    });
}

function createSplitTimeline(elem) {
    let split = new SplitText(elem, {
        type: "lines, words",
        linesClass: "lines"
    });
    let spacing = []
    for (let j = 0; j < split.lines.length; j++) {
        spacing.push(j * 40);
    }
    let tl = gsap.timeline({})
        .fromTo(split.lines, {
            yPercent: gsap.utils.wrap(spacing),
            immediateRender: true
        }, {
            yPercent: 0,
            duration: 0.5,
            ease: "slow"
        });
    return {
        tl: tl,
        split: split
    };
}

function addSplit() {
    addEmptySpans();

    let paragraphs = $('.splitScroll');

    paragraphs.each(function (i, elem) {
        let splitObj = createSplitTimeline(elem);
        let tween = splitObj.tl;
        let split = splitObj.split;
        let scene = new ScrollMagic.Scene({
            triggerElement: elem,
            triggerHook: 0.8,
        })
            .setTween(tween)
            .addTo(controller)

        splits.push({
            tween: tween,
            split: split,
            scene: scene,
            elem: elem
        });
    });
}

function recreateSplit() {
    for (var i = 0; i < splits.length; i++) {
        var split = splits[i];
        var elem = split.elem;
        split.split.revert();
        var splitObj = createSplitTimeline(elem);
        split.split = splitObj.split;
        split.tween = splitObj.tl;

        try {
            split.scene.setTween(split.tween);
        } catch (e) { }

    }
}

function VideoSprite(vars, options) {
    let $this = this;
    this.name = vars.name;
    this.container = vars.container;
    this.canvas = this.container.querySelector("canvas", {
        alpha: true
    });
    this.parent = vars.parent;
    this.options = options;

    this.width = vars.parent ? this.parent.clientWidth : window.innerWidth;
    this.height = vars.parent ? this.parent.clientWidth / options.ratio : window.innerHeight;
    this.width *= canvasDensity;
    this.height *= canvasDensity;

    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.ctx = this.canvas.getContext("2d");
    this.images = [];
    this.videoLoaded = false;
    this.currentFrame = "last";
    this.lastFrame = new Image();
    this.lastFrame.src = this.options.baseURL + this.options.lastFrame;

    this.lastFrame.addEventListener("load", function () {
        $this.draw();
    });

    this.load = function (callback) {
        let promises = [];
        for (let i = 0; i < $this.options.frameCount; i++) {
            promises.push(
                new Promise((resolve) => {
                    let img = new Image();
                    img.src = $this.options.baseURL + (i).toString().padStart($this.options.numberPadding, "0") + $this.options.extension || ".jpg";

                    $this.images[i] = img;

                    img.addEventListener("load", function (e) {
                        // noinspection JSUnresolvedFunction
                        e.target.setAttribute("data-loaded", "true");
                        resolve(true);
                    });

                    img.addEventListener("error", function (e) {
                        // noinspection JSUnresolvedFunction
                        e.target.setAttribute("data-loaded", "false");
                        resolve(true);
                    });
                })
            )
        }

        Promise.all(promises).then(() => {
            $this.videoLoaded = true;
            callback();
        });
    }

    this.draw = function () {
        // if (this.canvas.getAttribute("data-visible") === "false") return;
        let img;
        if (this.currentFrame === "last") {
            img = this.lastFrame
        } else {
            img = this.images[this.currentFrame];
        }

        if (img) {
            try {
                let y = (this.height - this.width / this.options.ratio) / 2;
                this.ctx.drawImage(img, 0, y, this.width, this.width / this.options.ratio);
            } catch (error) {
                console.log("error loading image: " + img.src);
            }
        }
    }

    window.addEventListener('resize', function () {
        if ($this.parent) {
            $this.width = $this.parent.clientWidth;
            $this.height = $this.parent.clientWidth / $this.options.ratio;
        } else {
            $this.width = window.innerWidth;
            $this.height = window.innerHeight;
        }

        $this.width *= canvasDensity;
        $this.height *= canvasDensity;

        $this.canvas.width = $this.width;
        $this.canvas.height = $this.height;
    });
}

function lazyLoadSprites() {

    let totalLoaded = 0;

    for (let i = 0; i < sprites.length; i++) {
        let videoSprite = sprites[i];
        if (videoSprite.videoLoaded) {
            totalLoaded++;
        } else {
            videoSprite.load(lazyLoadSprites);
            break;
        }
    }
}

function lazyLoadContent() {

    let imgObserver = new IntersectionObserver((entries) => {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.src = $(entry.target).data("src");
                if (entry.target.tagName === "video") entry.target.load();
                imgObserver.unobserve(entry.target);
            }
        });
    }, {
        root: null,
        rootMargin: "1500px",
        threshold: 0
    });

    $("video[data-src],img[data-src]").each(function (i, elem) {
        imgObserver.observe(elem);
    });

    lazyLoadSprites()
}

function navboxScrollEffect() {
    let lastScrollTop = 0;
    let $window = $(window);
    let headerHeight = $(".header").height();

    let tl = gsap.timeline({
        paused: true,
        onReverseComplete: function () {
            gsap.delayedCall(3, function () {
                if ($window.scrollTop() > wh && !$(".header__burger").hasClass("is-animated")) {
                    tl.play();
                }
            });
        }
    })
        .to(".header", {
            scaleY: 0,
            transformOrigin: "50% 0%",
            duration: 0.3,
            ease: "power2.inOut"
        })
        .to(".main__navbox", {
            y: -headerHeight,
            duration: 0.3,
            ease: "power2.inOut"
        }, 0)

    $window.on("scroll", function () {
        let st = $window.scrollTop();
        if (st > lastScrollTop && st > wh / 2 && updateEasingScenes) {
            tl.play();
        } else if (updateEasingScenes) {
            tl.reverse();
        }
        lastScrollTop = st;
    });
}

function changeHeaderColor() {

    let tl = gsap.timeline({
        paused: true,
        defaults: {
            duration: 0.5,
            ease: "sine.inOut"
        }
    })
        .to(".header, .menu", {
            backgroundColor: "black"
        }, 0)
        .to(".header__logo, .navbox, .navbox--buy", {
            filter: "invert(100%)"
        }, 0)
      .to(
        ".header__nav ul li a, .menu__in ul li a",
        {
          color: "#fff",
        },
        0
      )
      .to(
        ".header__controls svg *",
        {
          fill: "#fff",
        },
        0
      )
      .to(
        ".header__burger i",
        {
          background: "#fff",
        },
        0
      )

    if (!isMobile) {
        tl.to(".navbox--buy b", {
            filter: "invert(100%)"
        }, 0)
    }


    let blackScene = new ScrollMagic.Scene({
        triggerElement: ".main-power",
        triggerHook: 0
    })
        .on("enter", function () {
            tl.play()
        })
        .on("leave", function () {
            tl.reverse()
        })
        .addTo(controller);

    let whiteScene = new ScrollMagic.Scene({
        triggerElement: ".main-interactive",
        triggerHook: 0
    })
        .on("enter", function () {
            tl.reverse()
        })
        .on("leave", function () {
            tl.play()
        })
        .addTo(controller);
}

function designScaleDown() {
    let designBackground = document.querySelector(".main-design__background");
    let tween = gsap.to({}, {})
    let follower = gsap.timeline({
        paused: true
    })

        .fromTo(designBackground, {
            scale: 1
        }, {
            scale: function () {
                let scale = isSmallDesktop ? 0.9 : 0.8;
                scale = isTablet ? 1 : scale;
                return scale;
            }
        });

    let scene = new ScrollMagic.Scene({
        triggerElement: ".main-design__heading",
        triggerHook: 0.5,
        duration: "70%"
    })
        .setTween(tween)
        .addTo(controller)

    easeScenes.push({
        tween: tween,
        follower: follower,
        scene: scene,
        update: function () {
            follower.invalidate();
            follower.render(follower.time(), false, true);
        }
    });
}

function designParallax() {
    let imageLeft = document.querySelectorAll(".main-design__gallery--left .gallery_image");
    let imageRight = document.querySelector(".main-design__gallery--right .gallery_image");
    let imageBottom = document.querySelector(".main-design__gallery--bottom .gallery_image");

    let tween = gsap.to({}, {})
    let follower = gsap.timeline({
        paused: true
    })
        .set(imageRight, {
            scale: 1.1,
            immediateRender: true
        })
        .set(imageLeft, {
            scale: 1.1,
            immediateRender: true
        })
        .set(imageBottom, {
            scale: 1.1,
            immediateRender: true
        })
        .from(imageLeft, {
            yPercent: -10,
            duration: 1.1
        })
        .fromTo(imageRight, {
            yPercent: 5
        }, {
            yPercent: -5,
            duration: 1.1
        }, 0)
        .fromTo(imageBottom, {
            yPercent: -10
        }, {
            yPercent: 10
        })

    let scene = new ScrollMagic.Scene({
        triggerElement: ".main-design__gallery",
        triggerHook: 0.5,
        duration: "250%"
    })
        .setTween(tween)
        .addTo(controller)

    easeScenes.push({
        tween: tween,
        follower: follower,
        scene: scene
    });
}

function scrollBikeFrame() {
    // let triggerHook = isMobile ? 0.8 : 0.5;
    let obj = {
        value: 0
    };
    let pos = 0

    let block = false


    $(document).ready(function () {
        play_to(points.zero_in_p1.from, points.zero_in_p1.from, false, 0)
    });

    // click event
    const play_to = (pos_from, pos_to, done, position) => {
        if (!block) {
            block = true
            updateFrames(geometryFrame, {
                value: pos_from
            })
            gsap.fromTo(obj, {
                value: pos_from
            },
                {
                    value: pos_to,
                    duration: 0.75,
                    onUpdate: function () {
                        updateFrames(geometryFrame, obj);
                    },
                    onComplete: () => {
                        if (done) {
                            obj.value = 0
                            updateFrames(geometryFrame, obj)
                        }
                        pos = position
                        console.log(pos)
                        block = false
                    }
                })
        }
    }

    let points = {
        zero_in_p1: {
            from: 0,
            to: 0.1666
        },
        zero_in_p2: {
            from: 0.1666,
            to: 0.3333
        },
        zero_in_p3: {
            from: 0.3333,
            to: 0.5
        },
        p1_in_p2: {
            from: 0.5,
            to: 0.6666
        },
        p1_in_p3: {
            from: 0.6666,
            to: 0.8333
        },
        p2_in_p3: {
            from: 0.8333,
            to: 1
        },
    }

    // Click on first btn
    $('#play_geometry_1').on('click', () => {
        const { zero_in_p1, zero_in_p2, zero_in_p3, p1_in_p2, p1_in_p3, p2_in_p3 } = points
        switch (pos) {
            case 0:
                play_to(zero_in_p1.from, zero_in_p1.to * 0.98, false, 1)
                break;
            case 2:
                play_to(p1_in_p2.to, p1_in_p2.from * 1.02, false, 1)
                break;
            case 3:
                play_to(p1_in_p3.to, p1_in_p3.from * 1.02, false, 1)
                break;
            case 1:
                play_to(zero_in_p1.to, zero_in_p1.from, false, 0)
                break;
        }
    })

    // Click on second btn
    $('#play_geometry_2').on('click', () => {
        const { zero_in_p1, zero_in_p2, zero_in_p3, p1_in_p2, p1_in_p3, p2_in_p3 } = points
        switch (pos) {
            case 0:
                play_to(zero_in_p2.from, zero_in_p2.to, false, 2)
                break;
            case 2:
                play_to(zero_in_p2.to, zero_in_p2.from, false, 0)
                break;
            case 3:
                play_to(p2_in_p3.to, p2_in_p3.from * 1.01, false, 2)
                break;
            case 1:
                play_to(p1_in_p2.from, p1_in_p2.to, false, 2)
                break;
        }
    })

    // Click on third btn
    $('#play_geometry_3').on('click', () => {
        const { zero_in_p1, zero_in_p2, zero_in_p3, p1_in_p2, p1_in_p3, p2_in_p3 } = points
        switch (pos) {
            case 0:
                play_to(zero_in_p3.from, zero_in_p3.to, false, 3)
                break;
            case 2:
                play_to(p2_in_p3.from * 1.01, p2_in_p3.to, false, 3)
                break;
            case 3:
                play_to(zero_in_p3.to, zero_in_p3.from * 1.02, false, 0)
                break;
            case 1:
                play_to(p1_in_p3.from * 1.02, p1_in_p3.to, false, 3)
                break;
        }
    })

    $('#frame-canvas').on('click', () => {
        const { zero_in_p1, zero_in_p2, zero_in_p3, p1_in_p2, p1_in_p3, p2_in_p3 } = points
        switch (pos) {
            case 2:
                play_to(zero_in_p2.to, zero_in_p2.from, false, 0)
                break;
            case 3:
                play_to(zero_in_p3.to, zero_in_p3.from * 1.02, false, 0)
                break;
            case 1:
                play_to(zero_in_p1.to, zero_in_p1.from, false, 0)
                break;
        }
    })

    // To zero
    const to_init = (from, to) => {
        if (obj.value !== 0) {
            play_to(from, to * 0.95, true)
        }
    }


    // let tween = gsap.to({}, {})
    // let follower = gsap.timeline({
    //     paused: true,
    //     onUpdate: function () {
    //         updateFrames(geometryFrame, obj);
    //     }
    // })
    //     .to({}, {})
    //     .to(obj, {
    //         value: 0,
    //         duration: 0.1
    //     }, 0)
    //     // .to(obj, {
    //     //     value: 1,
    //     //     duration: 0.8,
    //     // }, 0.1)
    //     // .to(obj, {
    //     //     value: 1,
    //     //     duration: 0.1
    //     // });

    // let scene = new ScrollMagic.Scene({
    //     triggerElement: ".main-frame__image",
    //     triggerHook: triggerHook,
    //     duration: "60%"
    // })
    //     .setTween(tween)
    //     .addTo(controller)

    // easeScenes.push({
    //     tween: tween,
    //     follower: follower,
    //     scene: scene,
    //     isSprite: true,
    //     sprite: "frame"
    // });
}

function frameCoverAnimation() {
    let text = document.querySelector(".main-frame__text")
    let zoom = document.querySelector(".main-frame__zoom")
    let textBox = text.getBoundingClientRect();
    let zoomBox = zoom.getBoundingClientRect();

    let push = Math.abs((textBox.top + textBox.height / 2) - (zoomBox.top + zoomBox.height / 2));
    if (textBox.height > zoomBox.height) push = Math.abs(textBox.bottom - zoomBox.bottom);

    let tween;
    tween = gsap.timeline({})

    let scene = new ScrollMagic.Scene({
        triggerElement: ".main-frame__text",
        triggerHook: 0.3,
        duration: push
    })
        .setPin(".main-frame__text p", {
            pushFollowers: false
        })
        .setTween(tween)
        .addTo(controller)

    document.querySelector(".main-frame__zoom img").addEventListener("load", function () {
        let textBox = text.getBoundingClientRect();
        let zoomBox = zoom.getBoundingClientRect();
        let push = Math.abs((textBox.top + textBox.height / 2) - (zoomBox.top + zoomBox.height / 2));
        if (textBox.height > zoomBox.height) push = Math.abs(textBox.bottom - zoomBox.bottom);

        scene.duration(push);
    });

    scrollingScenes.push({
        tween: tween,
        scene: scene,
        update: function () {
            let textBox = text.getBoundingClientRect();
            let zoomBox = zoom.getBoundingClientRect();
            let push = Math.abs((textBox.top + textBox.height / 2) - (zoomBox.top + zoomBox.height / 2));
            if (textBox.height > zoomBox.height) push = Math.abs(textBox.bottom - zoomBox.bottom);

            scene.duration(push);
        }
    });
}

function playSuspensionVideo() {
    if ($('suspensionVideo').length) {

    let played = false;
    let playButton = $(".main-suspension__play a");
    let suspensionVideo = document.querySelector("#suspensionVideo");
    let scene = new ScrollMagic.Scene({
        triggerElement: ".main-suspension__image",
        triggerHook: 0.6,
    })
        .on("enter", function () {
            if (!played) {
                suspensionVideo.play();
                played = true;

                if (suspensionVideo.readyState >= 1) {
                    suspensionVideo.play();
                    played = true;
                } else {
                    suspensionVideo.addEventListener("canplay", function () {
                        suspensionVideo.play();
                        played = true;
                    })
                }
            }
        })
        .addTo(controller)

    scrollingScenes.push({
        scene: scene
    });

    suspensionVideo.addEventListener("play", function () {
        gsap.to(playButton, {
            opacity: 0,
            duration: 0.3
        })
    });

    suspensionVideo.addEventListener("ended", function () {
        gsap.to(playButton, {
            opacity: 1,
            duration: 0.3
        })
    });

    playButton.on("click", function (e) {
        e.preventDefault();

        playVideo(suspensionVideo);
    });
    }
}

function powerScaleDown() {
    let sceneDuration = 0.6;
    let triggerHook = 0;
    let scaleDown = gsap.fromTo(".main-power__background", {
        scale: 1
    }, {
        scale: function () {
            let scale = 1;
            if (isDesktop) scale = 0.8;
            if (isSmallDesktop) scale = 0.9;
            return scale;
        },
        duration: 0.3
    })

    let powerTextTl = gsap.timeline({})
        .to(".main-power__gradient", {
            yPercent: -33.33,
            duration: 0.3
        }, 'translateIn')
        .from(".main-power__heading", {
            yPercent: 100,
            duration: 0.3
        }, 'translateIn')

    let tween = gsap.to({}, {
        duration: 0.3
    });

    let follower = gsap.timeline({
        paused: true
    })
        .add(scaleDown)
        .add(powerTextTl, 0)

    let scene = new ScrollMagic.Scene({
        triggerElement: ".main-power",
        duration: "60%"
    })
        .setTween(tween)
        .addTo(controller)

    let easingScene = {
        tween: tween,
        follower: follower,
        scene: scene,
        update: function () {
            let height = $(".main-power__sticky").height();
            triggerHook = Math.max(0, (wh / 2 - height / 2) / wh);
            scene.triggerHook(triggerHook)
            gsap.set(".main-power__sticky", {
                top: wh * triggerHook
            })
            $(".main-power").height(height + wh * sceneDuration);

            scaleDown.invalidate();
            follower.render(follower.time(), false, true);
        }
    }
    easeScenes.push(easingScene)
    easingScene.update();
}

function scrollMobileMotor() {
    let obj = {
        value: 0
    };

    let tween = gsap.to({}, {})
    let follower = gsap.timeline({
        paused: true,
        onUpdate: function () {
            updateFrames(motor, obj);
        }
    })
        .to({}, {})
        .to(obj, {
            value: 0,
            duration: 0.1
        }, 0)
        .to(obj, {
            value: 1,
            duration: 0.8,
        }, 0.1)
        .to(obj, {
            value: 1,
            duration: 0.1
        });

    let scene = new ScrollMagic.Scene({
        triggerElement: ".main-motor__image",
        triggerHook: 0.8,
        duration: "60%"
    })
        .setTween(tween)
        .addTo(controller)

    easeScenes.push({
        tween: tween,
        follower: follower,
        scene: scene,
        isSprite: true,
        sprite: "motor"
    });
}

function scrollMotorFrames() {
    let obj = {
        value: 0
    };

    let tween = gsap.to({}, {})
    let follower = gsap.timeline({
        paused: true,

        onUpdate: function () {
            updateFrames(motor, obj);
        }
    })
        .to(obj, {
            value: 0,
            duration: 0.02
        }, 0)
        .to(obj, {
            value: 1,
            duration: 0.98,
        }, 0.02)
        .to(obj, {
            value: 1,
            duration: 0.1
        })
        .to("#motorOverlay", {
            opacity: 0.8,
            duration: 0.5
        }, 1)
        .from(".main-motor .main-motor__specs_wrapper", {
            yPercent: 100
        }, 0.5)
        .from(".main-motor .specs__col", {
            yPercent: 150,
            delay: (i) => {
                return 0.2 * ((i % 3) + 1)
            },
            duration: 0.5
        }, 0.5)
        .to({}, {
            duration: 0.05
        });

    let scene = new ScrollMagic.Scene({
        triggerElement: ".main-motor__image",
        triggerHook: 0,
        duration: "150%"
    })
        .setPin(".main-motor__image")
        .setTween(tween)
        .addTo(controller)

    easeScenes.push({
        tween: tween,
        follower: follower,
        scene: scene,
        isSprite: true,
        sprite: "motor"
    })

}

function motorBoxTextAnimation() {
    let duration = $(".motor-box__wrapper").height();
    let tween = gsap.to({}, {})
    let follower = gsap.timeline({
        paused: true
    })

        .fromTo(".main-motor-box.one .main-motor-box__image", {
            yPercent: 20,
            immediateRender: true
        }, {
            yPercent: -20
        })

        .fromTo(".main-motor-box.two .main-motor-box__image", {
            yPercent: 20,
            immediateRender: true
        }, {
            yPercent: -20
        }, 0.3)

    let scene = new ScrollMagic.Scene({
        triggerElement: ".main-motor-box.one",
        triggerHook: 0.5,
        duration: duration
    })
        .setTween(tween)
        .addTo(controller)

    easeScenes.push({
        tween: tween,
        follower: follower,
        scene: scene,
        update: function () {
            scene.duration($(".motor-box__wrapper").height());
        }
    });

    $(".motor-box__wrapper img").each(function () {
        if (this.complete) {
            scene.duration($(".motor-box__wrapper").height());
        } else {
            $(this).on("load", function () {
                scene.duration($(".motor-box__wrapper").height());
            })
        }
    });
}

function scrollBatteryFrames() {
    let obj = {
        value: 0
    };
    let tween = gsap.to({}, {})
    let follower = gsap.timeline({
        paused: true,
        onUpdate: function () {
            updateFrames(battery, obj);
        }
    })
        .to({}, {})
        .to(obj, {
            value: 0,
            duration: 0.1
        }, 0)
        .to(obj, {
            value: 1,
            duration: 0.8,
        }, 0.1)
        .to(obj, {
            value: 1,
            duration: 0.1
        })
        .from(".main-battery__specs", {
            yPercent: 100,
            stagger: 0.2,
            duration: 0.4
        }, 1)
        .from(".main-battery .specs__col", {
            yPercent: 100,
            stagger: 0.2,
            duration: 0.4
        }, 1)
        .to({}, {
            duration: 0.03
        });
    let scene = new ScrollMagic.Scene({
        triggerElement: ".main-battery__image",
        triggerHook: 0,
        duration: "150%"
    })
        .setPin(".main-battery__image")
        .setTween(tween)
        .addTo(controller);

    easeScenes.push({
        tween: tween,
        follower: follower,
        scene: scene,
        isSprite: true,
        sprite: "battery"
    })
}

function displayTextScroll() {
    let displayScreens = $(".display_screen");
    let changeImage = gsap.timeline();
    let stickyWrapper = $(".main-display__sticky_wrapper");
    gsap.set(displayScreens, {
        opacity: 0
    })
    gsap.set(displayScreens[0], {
        opacity: 1
    })
    displayScreens.each(function (i, elem) {
        changeImage.to(elem, {
            opacity: 1
        });
        changeImage.to({}, {
            duration: 2
        });
    });

    let tween = gsap.timeline()
    tween.add(changeImage);

    let scene = new ScrollMagic.Scene({
        triggerElement: stickyWrapper[0]
    })
        .setTween(tween)
        .addTo(controller)

    let scrollingScene = {
        tween: tween,
        scene: scene,
        update: function () {
            let text = document.querySelector(".main-display__features ul")
            let display = document.querySelector(".main-display__display")
            let textBox = text.getBoundingClientRect();
            let displayBox = display.getBoundingClientRect();
            let push = Math.max(0, textBox.height - displayBox.height);
            stickyWrapper.height(push + displayBox.height);
            let triggerHook = ($(".header").height() + $(".main__navbox").height() + 10) / wh;
            triggerHook = isMobile ? 0.4 : triggerHook;
            gsap.set(display, {
                top: triggerHook * wh
            });
            scene.triggerHook(triggerHook);
            scene.duration(push);
        }
    }
    scrollingScenes.push(scrollingScene);
    scrollingScene.update();
}

function displayAssembly() {
    let boxImages = $('.main-display-info__image.original img').toArray().reverse();
    let triggerHook = isMobile ? 1 : 1;
    let tween = gsap.to({}, {})
    let specsAssembly = gsap.timeline({
        paused: true
    })
        .from(boxImages, {
            yPercent: 150,
            duration: 1,
            delay: function (i) {
                if (i > boxImages.length - 2) {
                    return (boxImages.length - 1) * 0.25;
                } else {
                    return (i + 1) * 0.25;
                }
            }
        }, 'specs')
    let follower = gsap.timeline({
        paused: true
    })
        .to({}, {
            duration: 0.1
        })
        .from('.main-display-info_dots', {
            yPercent: 100
        }, 'specs')
        .from('.main-display-info__specs', {
            yPercent: 300
        }, 'specs')
        .from('.main-display-info__image.original', {
            yPercent: 300
        }, 'specs')
        .to(specsAssembly, {
            progress: 1,
            duration: 5,
            ease: "slow( 0.7, 1, false)"
        }, 'specs')
        .from('.main-display-info__specs li', {
            opacity: 0,
            stagger: 0.1
        }, '-=0.5')
        .to({}, {
            duration: 0.1
        });

    let scene = new ScrollMagic.Scene({
        triggerElement: '.main-display-info',
        triggerHook: triggerHook,
        duration: '90%'
    })
        .setTween(tween)
        .addTo(controller)

    easeScenes.push({
        tween: tween,
        follower: follower,
        scene: scene
    })
}

function playAsistVideo() {
    let played = false;
    let playButton = $(".main-asist__play a");
    let asistVideo = document.querySelector("#asistVideo");
    let scene = new ScrollMagic.Scene({
        triggerElement: ".main-asist__video",
        triggerHook: 0.6,
    })
        .on("enter", function () {
            if (!played) {
                suspensionVideo.play();
                played = true;

                if (asistVideo.readyState >= 1) {
                    asistVideo.play();
                    played = true;
                } else {
                    asistVideo.addEventListener("canplay", function () {
                        asistVideo.play();
                        played = true;
                    })
                }
            }
        })
        .addTo(controller)

    scrollingScenes.push({
        scene: scene
    });

    asistVideo.addEventListener("play", function () {
        gsap.to(playButton, {
            opacity: 0,
            duration: 0.3
        })
    });

    asistVideo.addEventListener("ended", function () {
        gsap.to(playButton, {
            opacity: 1,
            duration: 0.3
        })
    });

    playButton.on("click", function (e) {
        e.preventDefault();
        playVideo(asistVideo);
    });


}

function playVideo(video) {
    let offset = $('.header').height() + $(".navbox").outerHeight();
    offset = isMobile ? offset : 0;
    let box = video.getBoundingClientRect();

    video.currentTime = 0;
    video.play();

    if (box.top < offset) {
        $('html, body').animate({
            scrollTop: $(video).offset().top - offset
        }, 500, "swing");
    }
}

function appTextScroll() {
    let stickyWrapper = $(".phone__sticky_wrapper");
    let displayScreens = $(".app_screen");
    let text = document.querySelector(".main-application__features ul");
    let display = document.querySelector(".main-application__phone");

    gsap.set(displayScreens, {
        opacity: 0
    })
    gsap.set(displayScreens[0], {
        opacity: 1
    })

    let changeImage = gsap.timeline();
    displayScreens.each(function (i, elem) {
        changeImage.to(elem, {
            opacity: 1
        });
        changeImage.to({}, {
            duration: 2
        });
    });

    let tween = gsap.timeline()
    tween.add(changeImage);

    let scene = new ScrollMagic.Scene({
        triggerElement: stickyWrapper[0],
    })

        .setTween(tween)
        .addTo(controller)

    let scrollingScene = {
        scene: scene,
        update: function () {
            let textBox = text.getBoundingClientRect();
            let displayBox = display.getBoundingClientRect();
            let triggerHook;
            let push = Math.max(0, textBox.height - displayBox.height);
            triggerHook = ($(".header").height() + $(".main__navbox").height() + 10) / wh;
            gsap.set(stickyWrapper, {
                height: displayBox.height + push
            })
            gsap.set(display, {
                top: triggerHook * wh
            })
            scene.triggerHook(triggerHook);
            scene.duration(push);
        }
    }

    scrollingScenes.push(scrollingScene);
    scrollingScene.update();
    document.querySelector(".main-application__in .app_screen").addEventListener("load", function () {
        scrollingScene.update();
    });
}

function bikeGalleryParallax() {
    let imageTop = document.querySelectorAll(".bike-gallery__top img");
    let imageLeft = document.querySelectorAll(".bike-gallery__left img");
    let imageRight = document.querySelector(".bike-gallery__right img");
    let imageBottom = document.querySelector(".bike-gallery__bottom img");
    let bikeGallery = $(".bike-gallery");
    let galleryTop = $(".bike-gallery__top");
    let galleryMiddle = $(".bike-gallery__middle");
    let galleryBottom = $(".bike-gallery__bottom");

    let tween = gsap.to({}, {})
    let follower = gsap.to({}, {});

    let scene = new ScrollMagic.Scene({
        triggerElement: ".bike-gallery",
        triggerHook: 0.9
    })
        .setTween(tween)
        .addTo(controller)

    let easingScene = {
        tween: tween,
        follower: follower,
        scene: scene,
        update: function () {
            let galleryHeight = bikeGallery.height() + wh / 2,
                topHeight = galleryTop.height(),
                middleHeight = galleryMiddle.height(),
                bottomHeight = galleryBottom.height();

            easingScene.follower = gsap.timeline({
                paused: true
            })
                .set(imageTop, {
                    scale: 1.1,
                    immediateRender: true
                })
                .set(imageRight, {
                    scale: 1.1,
                    immediateRender: true
                })
                .set(imageLeft, {
                    scale: 1.3,
                    immediateRender: true
                })
                .set(imageBottom, {
                    scale: 1.1,
                    immediateRender: true
                })
                .fromTo(imageTop, {
                    yPercent: -10
                }, {
                    yPercent: 10,
                    duration: topHeight / galleryHeight
                })
                .fromTo(imageLeft, {
                    yPercent: 5,
                }, {
                    yPercent: -15,
                    duration: middleHeight / galleryHeight
                }, topHeight / galleryHeight)
                .fromTo(imageRight, {
                    yPercent: -10
                }, {
                    yPercent: 10,
                    duration: middleHeight / galleryHeight
                }, topHeight / galleryHeight)
                .fromTo(imageBottom, {
                    yPercent: -10
                }, {
                    yPercent: 10,
                    duration: bottomHeight / galleryHeight
                });

            scene.duration(galleryHeight);
        }
    }
    easingScene.update();

    $(".bike-gallery img").each(function () {
        if (this.complete) {
            easingScene.update();
        } else {
            $(this).on("load", imageLoaded);

            function imageLoaded() {
                $(this).off("load", imageLoaded);
                easingScene.update();
            }
        }
    });

    easeScenes.push(easingScene);
}

function universeOfColorsFrames() {

    let obj = {
        value: 0
    }

    updateFrames(colors, obj)

    const tl = gsap.timeline({})

    ScrollTrigger.create({
        trigger: "#main-colors",
        start: "top top",
        end: "bottom 100%",
        pin: "#colors-canvas",
        // markers: true,
        scrub: 1,
        toggleActions: "restart pause reverse pause",
        onUpdate: self => {
            gsap.to(obj, {
                value: self.progress.toFixed(3),
                duration: 0.2,
                onUpdate: () => {
                    updateFrames(colors, obj)
                }
            })
        },
    });

    gsap.to("#colors-inner .wrapper", {
        scrollTrigger: {
            trigger: "#colors-inner",
            start: "top top",
            end: "center center",
            scrub: 1
        },
        color: '#fff'
    });
}

function cityIntroScroll() {
    let obj = {
        value: 0
    }

    // updateFrames(colors, obj)

    ScrollTrigger.create({
        trigger: "#city_intro",
        start: "top top",
        end: "500px top",
        pin: "#city_intro_bg",
        type: 'fixed',
        // markers: true,
    })

    gsap.to("#city_intro .hide-on-scroll", {
        scrollTrigger: {
            trigger: "#city_intro .wrapper",
            start: "40px 810px",
            end: "120px 810px",
            scrub: 1,
            // markers: true,
        },
        autoAlpha: 0
    });

    gsap.to("#city_house-bg", {
        scrollTrigger: {
            trigger: "#city_house",
            start: "top center",
            end: "bottom center",
            scrub: 1,
            // markers: true,
        },
        scale: 1.1
    });
}
